import { UseEvaluationPercentageArgs } from "./useEvaluationPercentage.decl";

export function useEvaluationPercentage({
  points,
  maximumPoints,
}: UseEvaluationPercentageArgs) {
  const percentage = Math.round((points / (maximumPoints || 1)) * 100);

  return {
    percentage,
  };
}
